export const AGORA_CONFIG = {
  codec: 'vp8',
  mode: 'live',
  logLevelAllLogs: 0,
  logLevelError: 3,
  proxyMode: 5,
} as const
